import {
  UnorderedListOutlined,
  PlusCircleOutlined,
  SettingOutlined,
  DeploymentUnitOutlined,
  ContactsOutlined,
  ExperimentOutlined,
  ControlOutlined,
  TeamOutlined,
  DatabaseOutlined,
  SafetyCertificateOutlined,
  ShoppingOutlined,
  ShoppingCartOutlined,
  FileSearchOutlined,
  UserAddOutlined,
  FileUnknownOutlined,
  ShopOutlined,
  CalendarOutlined,
  WalletOutlined,
  DotChartOutlined,
  FundOutlined,
  BarChartOutlined,
  TransactionOutlined,
  TruckOutlined,
  MedicineBoxOutlined,
  AuditOutlined,
  FileTextOutlined,
  BankOutlined,
  CustomerServiceOutlined,
  SolutionOutlined,
  BuildOutlined,
  CarryOutOutlined,
  BookOutlined,
  DashboardOutlined,
  HistoryOutlined,
  FileProtectOutlined,
  FieldTimeOutlined,
  ContainerOutlined,
  AppstoreOutlined,
  AccountBookOutlined,
  ApartmentOutlined,
  DollarCircleOutlined,
} from '@ant-design/icons';

import PERMISSIONS from '../../libs/permissions';

export const Modules = [
  // 1 Home
  {
    type: 'list',
    title: 'Home',
    key: 'Home.Module',
    icon: <DashboardOutlined />,
    subModules: [
      {
        type: 'list',
        title: 'Dashboards',
        key: 'Dashboards.Module',
        icon: <DashboardOutlined />,
        subModules: [
          {
            type: 'item',
            module: PERMISSIONS.accountDepartmentDashboard,
            title: 'Account',
            key: 'Account',
            link: '/dashboard/account',
            icon: <FundOutlined />,
          },
          {
            type: 'item',
            module: PERMISSIONS.orderDashboard,
            title: 'Dashboard',
            key: 'Dashboard',
            link: '/dashboard',
            icon: <FundOutlined />,
          },
          {
            type: 'item',
            module: PERMISSIONS.ppicDepartmentDashboard,
            title: 'PPIC',
            key: 'PPIC',
            link: '/dashboard/ppic',
            icon: <FundOutlined />,
          },
          {
            type: 'item',
            module: PERMISSIONS.productionDepartmentDashboard,
            title: 'Production',
            key: 'Production.Dashboard',
            link: '/dashboard/production',
            icon: <FundOutlined />,
          },
          {
            type: 'item',
            module: PERMISSIONS.qualityDepartmentDashboard,
            title: 'Quality',
            key: 'Quality',
            link: '/dashboard/quality',
            icon: <FundOutlined />,
          },
        ],
      },
      {
        type: 'list',
        title: 'Tasks',
        key: 'Task.Module',
        icon: <CarryOutOutlined />,
        subModules: [
          {
            type: 'item',
            module: PERMISSIONS.getChecklists,
            title: 'Checklists',
            key: 'Checklists',
            link: '/tasks/checklists',
            icon: <UnorderedListOutlined />,
          },
          {
            type: 'item',
            module: PERMISSIONS.getChecklists,
            title: 'Extensions',
            key: 'Task Extensions',
            link: '/tasks/extensions',
            icon: <FieldTimeOutlined />,
          },
          {
            type: 'item',
            module: PERMISSIONS.getPlannedScores,
            title: 'Planned Scores',
            key: 'Planned Scores',
            link: '/tasks/planned-scores',
            icon: <DotChartOutlined />,
          },
          // {
          //   type: 'item',
          //   module: PERMISSIONS.getWeeklyMis,
          //   title: 'MIS',
          //   key: 'Weekly MIS Report',
          //   link: '/tasks/weekly-mis',
          //   icon: <BarChartOutlined />,
          // },
        ],
      },
      {
        type: 'list',
        title: 'Requirements',
        key: 'HelpTickets.Module',
        icon: <CustomerServiceOutlined />,
        subModules: [
          {
            type: 'item',
            module: PERMISSIONS.getHelpTickets,
            title: 'Requirements',
            key: 'Requirements',
            link: '/help-tickets',
            icon: <UnorderedListOutlined />,
          },
          {
            type: 'item',
            module: PERMISSIONS.addHelpTicket,
            title: 'Add',
            key: 'Add',
            link: '/help-tickets/add',
            icon: <PlusCircleOutlined />,
          },
        ],
      },
      {
        type: 'item',
        module: PERMISSIONS.orderFMS,
        title: 'Order FMS',
        key: 'Order FMS',
        link: '/reports/orderfms',
        icon: <UnorderedListOutlined />,
      },
      {
        type: 'item',
        module: PERMISSIONS.userMIS,
        title: 'User MIS',
        key: 'User MIS',
        link: '/reports/user-mis',
        icon: <UnorderedListOutlined />,
      },
      {
        type: 'item',
        module: PERMISSIONS.salesMis,
        title: 'Sale MIS',
        key: 'Sale MIS',
        link: '/reports/sale-mis',
        icon: <UnorderedListOutlined />,
      },
      {
        type: 'item',
        module: PERMISSIONS.procurementFMS,
        title: 'Procurement FMS',
        key: 'Procurement FMS',
        link: '/reports/procurement-fms',
        icon: <UnorderedListOutlined />,
      },
      {
        type: 'item',
        module: PERMISSIONS.vendorScorecard,
        title: 'Vendor Scorecard',
        key: 'Vendor Scorecard',
        link: '/reports/vendor-scorecard',
        icon: <UnorderedListOutlined />,
      },
    ],
  },

  // 2 Sales
  {
    type: 'list',
    title: 'Sales',
    key: 'Sales.Module',
    icon: <ShopOutlined />,
    subModules: [
      {
        type: 'list',
        title: 'CRM',
        key: 'CRM.Module',
        icon: <SolutionOutlined />,
        subModules: [
          {
            type: 'item',
            module: PERMISSIONS.getLeads,
            title: 'Enquiry FMS',
            key: 'Enquiry FMS',
            link: '/crm/enquiry/fms',
            icon: <UnorderedListOutlined />,
          },
          {
            type: 'item',
            module: PERMISSIONS.getLeads,
            title: 'Calendar',
            key: 'Calendar',
            link: '/crm/interactions/calendar',
            icon: <CalendarOutlined />,
          },
          {
            type: 'item',
            module: PERMISSIONS.getLeads,
            title: 'Leads',
            key: 'Leads',
            link: '/crm/leads',
            icon: <UnorderedListOutlined />,
          },
          {
            type: 'item',
            module: PERMISSIONS.addLead,
            title: 'Add Lead',
            key: 'Add Lead',
            link: '/crm/leads/add',
            icon: <PlusCircleOutlined />,
          },
          {
            type: 'item',
            module: PERMISSIONS.getLeadOrigins,
            title: 'Origins',
            key: 'Origins',
            link: '/dropdowns/origins',
            icon: <UnorderedListOutlined />,
          },
        ],
      },
      {
        type: 'list',
        title: 'Quotations',
        key: 'Quotation.Module',
        icon: <FileSearchOutlined />,
        subModules: [
          {
            type: 'item',
            module: PERMISSIONS.getQuotations,
            title: 'Quotations',
            key: 'Quotations',
            link: '/quotations',
            icon: <UnorderedListOutlined />,
          },
          {
            type: 'item',
            module: PERMISSIONS.addQuotation,
            title: 'Add Quotation',
            key: 'Add Quotation',
            link: '/quotations/add',
            icon: <PlusCircleOutlined />,
          },
        ],
      },
      {
        type: 'list',
        title: 'Proforma',
        key: 'ProformaInvoice.Module',
        icon: <FileTextOutlined />,
        subModules: [
          {
            type: 'item',
            module: PERMISSIONS.getProformaInvoices,
            title: 'PI List',
            key: 'Proforma Invoices',
            link: '/proforma-invoices',
            icon: <UnorderedListOutlined />,
          },
          {
            type: 'item',
            module: PERMISSIONS.addProformaInvoice,
            title: 'Add PI',
            key: 'Add PI',
            link: '/proforma-invoices/add',
            icon: <PlusCircleOutlined />,
          },
        ],
      },
      {
        type: 'list',
        title: 'Sale Orders',
        key: 'SaleOrder.Module',
        icon: <FileProtectOutlined />,
        subModules: [
          {
            type: 'item',
            module: PERMISSIONS.getSaleOrders,
            title: 'Sale Orders',
            key: 'Sale Orders',
            link: '/sale-orders',
            icon: <UnorderedListOutlined />,
          },
          {
            type: 'item',
            module: PERMISSIONS.addSaleOrder,
            title: 'Add SO',
            key: 'Add SO',
            link: '/sale-orders/add',
            icon: <PlusCircleOutlined />,
          },
        ],
      },
    ],
  },

  // 3 Procurement
  {
    type: 'list',
    title: 'Procurement',
    key: 'Purchase.Root.Module',
    icon: <ShoppingCartOutlined />,
    subModules: [
      {
        type: 'list',
        title: 'RFQs',
        key: 'Rfqs.Module',
        icon: <FileSearchOutlined />,
        subModules: [
          {
            type: 'item',
            module: PERMISSIONS.getRfqs,
            title: 'RFQs',
            key: 'RFQs',
            link: '/rfqs',
            icon: <FileSearchOutlined />,
          },
        ],
      },
      {
        type: 'list',
        title: 'Purchase Orders',
        key: 'PurchaseOrders.Module',
        icon: <FileProtectOutlined />,
        subModules: [
          {
            type: 'item',
            module: PERMISSIONS.getPurchaseOrders,
            title: 'Calendar',
            key: 'PO Calendar',
            link: '/purchase-orders/calendar',
            icon: <CalendarOutlined />,
          },
          {
            type: 'item',
            module: PERMISSIONS.getPurchaseOrders,
            title: 'PO List',
            key: 'Purchase Orders',
            link: '/purchase-orders',
            icon: <UnorderedListOutlined />,
          },
          {
            type: 'item',
            module: PERMISSIONS.addPurchaseOrder,
            title: 'Add PO',
            key: 'Add PO',
            link: '/purchase-orders/add',
            icon: <PlusCircleOutlined />,
          },
        ],
      },
      {
        type: 'list',
        title: 'Purchases',
        key: 'Purchases.Module',
        icon: <ContainerOutlined />,
        subModules: [
          {
            type: 'item',
            module: PERMISSIONS.getPurchases,
            title: 'Purchases',
            key: 'Purchases',
            link: '/purchases',
            icon: <UnorderedListOutlined />,
          },
          {
            type: 'item',
            module: PERMISSIONS.addPurchase,
            title: 'Add Purchase',
            key: 'Add Purchase',
            link: '/purchases/add',
            icon: <PlusCircleOutlined />,
          },
        ],
      },
      {
        type: 'item',
        module: PERMISSIONS.purchasesWithoutTax,
        title: 'WithoutTax Report',
        key: 'Purchases Without Tax',
        link: '/reports/purchases-without-tax',
        icon: <UnorderedListOutlined />,
      },
      {
        type: 'list',
        title: 'Bills',
        key: 'Purchase.Bill.Module',
        icon: <AuditOutlined />,
        subModules: [
          {
            type: 'item',
            module: PERMISSIONS.addBill,
            title: 'Add Bill',
            key: 'Purchase Add Bill',
            link: '/accounts/bills/add',
            icon: <PlusCircleOutlined />,
          },
        ],
      },
    ],
  },

  // 4 Inventory
  {
    type: 'list',
    title: 'Inventory',
    key: 'Inventory.Module',
    icon: <DatabaseOutlined />,
    subModules: [
      {
        type: 'list',
        title: 'Product',
        key: 'Product.Inventory.Module',
        icon: <ExperimentOutlined />,
        subModules: [
          {
            type: 'item',
            module: PERMISSIONS.adjustProductInventory,
            title: 'Adjustments',
            key: 'Product Stock Adjustments',
            link: '/inventory/products/adjustments',
            icon: <UnorderedListOutlined />,
          },
          {
            type: 'item',
            module: PERMISSIONS.getProductInventory,
            title: 'Stock',
            key: 'Product Inventory',
            link: '/inventory/products',
            icon: <UnorderedListOutlined />,
          },
          {
            type: 'item',
            module: PERMISSIONS.getProductsToOrder,
            title: 'To Order',
            key: 'Products To Order',
            link: '/inventory/products-to-order',
            icon: <UnorderedListOutlined />,
          },
          {
            type: 'item',
            module: PERMISSIONS.transferProductInventory,
            title: 'Transfers',
            key: 'Product Stock Transfers',
            link: '/inventory/products/transfers',
            icon: <UnorderedListOutlined />,
          },
          {
            type: 'item',
            module: PERMISSIONS.adjustProductInventory,
            title: 'Adjust Form',
            key: 'Product Stock Adjust Form',
            link: '/inventory/products/adjustment-form',
            icon: <UnorderedListOutlined />,
          },
          {
            type: 'item',
            module: PERMISSIONS.transferProductInventory,
            title: 'Transfer Form',
            key: 'Product Stock Transfer Form',
            link: '/inventory/products/transfer-form',
            icon: <UnorderedListOutlined />,
          },
        ],
      },
      {
        type: 'list',
        title: 'Material',
        key: 'Material.Inventory.Module',
        icon: <DeploymentUnitOutlined />,
        subModules: [
          {
            type: 'item',
            module: PERMISSIONS.adjustMaterialInventory,
            title: 'Adjustments',
            key: 'Material Adjustments',
            link: '/inventory/materials/adjustments',
            icon: <UnorderedListOutlined />,
          },
          {
            type: 'item',
            module: PERMISSIONS.getMaterialInventory,
            title: 'Stock',
            key: 'Material Inventory',
            link: '/inventory/materials',
            icon: <UnorderedListOutlined />,
          },
          {
            type: 'item',
            module: PERMISSIONS.getMaterialsToOrder,
            title: 'To Order',
            key: 'Materials To Order',
            link: '/inventory/materialstoorder',
            icon: <UnorderedListOutlined />,
          },
          {
            type: 'item',
            module: PERMISSIONS.transferMaterialInventory,
            title: 'Transfers',
            key: 'Material Stock Transfers',
            link: '/inventory/materials/transfers',
            icon: <UnorderedListOutlined />,
          },
          {
            type: 'item',
            module: PERMISSIONS.adjustMaterialInventory,
            title: 'Adjust Form',
            key: 'Material Adjust Form',
            link: '/inventory/materials/adjustment-form',
            icon: <UnorderedListOutlined />,
          },
          {
            type: 'item',
            module: PERMISSIONS.transferMaterialInventory,
            title: 'Transfer Form',
            key: 'Material Stock Transfer Form',
            link: '/inventory/materials/transfer-form',
            icon: <UnorderedListOutlined />,
          },
        ],
      },
    ],
  },

  // 5 Orders & Production
  {
    type: 'list',
    title: 'Orders & Production',
    key: 'OrdersAndProduction.Module',
    icon: <BuildOutlined />,
    subModules: [
      {
        type: 'item',
        module: PERMISSIONS.notPunchedDashboard,
        title: 'Not Punched',
        key: 'Products Not punched as Orders',
        link: '/dashboard/notpunched',
        icon: <FileUnknownOutlined />,
      },
      {
        type: 'item',
        module: PERMISSIONS.getOrders,
        title: 'Orders',
        key: 'Orders',
        link: '/orders',
        icon: <ShoppingOutlined />,
      },
      {
        type: 'item',
        module: PERMISSIONS.addOrder,
        title: 'Add Order',
        key: 'Add Order',
        link: '/orders/add',
        icon: <PlusCircleOutlined />,
      },
      {
        type: 'item',
        module: PERMISSIONS.production,
        title: 'Production',
        key: 'Production',
        link: '/orders/production',
        icon: <ControlOutlined />,
      },
      {
        type: 'item',
        module: PERMISSIONS.getSales,
        title: 'Packing Pending',
        key: 'Packing Pending',
        link: '/dispatch/packing-pending',
        icon: <TruckOutlined />,
      },
    ],
  },

  // 6 Accounts & Finance
  {
    type: 'list',
    title: 'Accounts & Finance',
    key: 'AccountsAndFinance.Module',
    icon: <WalletOutlined />,
    subModules: [
      {
        type: 'list',
        title: 'Transactions',
        key: 'Accounts.Module',
        icon: <TransactionOutlined />,
        subModules: [
          {
            type: 'item',
            module: PERMISSIONS.getTransactions,
            title: 'Contra',
            key: 'Contra',
            link: '/accounts/transactions/contra',
            icon: <TransactionOutlined />,
          },
          {
            type: 'item',
            module: PERMISSIONS.getTransactions,
            title: 'Journals',
            key: 'Journals',
            link: '/accounts/transactions/journals',
            icon: <UnorderedListOutlined />,
          },
          {
            type: 'item',
            module: PERMISSIONS.viewPartyLedger,
            title: 'Party Ledger',
            key: 'Party Ledger',
            link: '/parties/ledger',
            icon: <WalletOutlined />,
          },
          {
            type: 'item',
            module: PERMISSIONS.getTransactions,
            title: 'Payments',
            key: 'Payments',
            link: '/accounts/transactions/payments',
            icon: <ShoppingCartOutlined />,
          },
          {
            type: 'item',
            module: PERMISSIONS.getTransactions,
            title: 'Receipts',
            key: 'Receipts',
            link: '/accounts/transactions/receipts',
            icon: <ShoppingOutlined />,
          },
          {
            type: 'item',
            module: PERMISSIONS.getSaleInvoiceDues,
            title: 'Sale Dues',
            key: 'Sale Invoice Dues',
            link: '/calendar/customer-dues',
            icon: <CalendarOutlined />,
          },
          {
            type: 'item',
            module: PERMISSIONS.getPurchaseInvoiceDues,
            title: 'Purchase Dues',
            key: 'Purchase Invoice Dues',
            link: '/calendar/purchase-dues',
            icon: <CalendarOutlined />,
          },
        ],
      },
      {
        type: 'list',
        title: 'Invoices & Billing',
        key: 'Sale.Module',
        icon: <FileTextOutlined />,
        subModules: [
          {
            type: 'item',
            module: PERMISSIONS.getSales,
            title: 'Invoices',
            key: 'Sale Invoices',
            link: '/sales',
            icon: <UnorderedListOutlined />,
          },
          {
            type: 'item',
            module: PERMISSIONS.addSale,
            title: 'Add Invoice',
            key: 'Add Sale / Challan',
            link: '/sales/add',
            icon: <PlusCircleOutlined />,
          },
        ],
      },
      {
        type: 'item',
        module: PERMISSIONS.salesWithoutTax,
        title: 'WithoutTax Report',
        key: 'Sales Without Tax',
        link: '/reports/sales-without-tax',
        icon: <UnorderedListOutlined />,
      },
      {
        type: 'list',
        title: 'Pre Invoices',
        key: 'PreInvoice.Module',
        icon: <FileTextOutlined />,
        subModules: [
          {
            type: 'item',
            module: PERMISSIONS.getPreSales,
            title: 'Pre Invoices',
            key: 'Pre Invoices',
            link: '/pre-sales',
            icon: <UnorderedListOutlined />,
          },
          {
            type: 'item',
            module: PERMISSIONS.addPreSale,
            title: 'Add Pre Invoice',
            key: 'Add Pre Invoice',
            link: '/pre-sales/add',
            icon: <PlusCircleOutlined />,
          },
        ],
      },
      {
        type: 'list',
        title: 'Bills',
        key: 'Accounts.Bill.Module',
        icon: <AuditOutlined />,
        subModules: [
          {
            type: 'item',
            module: PERMISSIONS.getBills,
            title: 'Bills',
            key: 'Bills',
            link: '/accounts/bills',
            icon: <UnorderedListOutlined />,
          },
          {
            type: 'item',
            module: PERMISSIONS.addBill,
            title: 'Add Bill',
            key: 'Accounts Add Bill',
            link: '/accounts/bills/add',
            icon: <PlusCircleOutlined />,
          },
        ],
      },
      {
        type: 'list',
        title: 'Credit/Debit',
        key: 'CDNS.Module',
        icon: <DollarCircleOutlined />,
        subModules: [
          {
            type: 'item',
            module: PERMISSIONS.getCDNs,
            title: 'Credit/Debit',
            key: 'Credit/Debit Notes',
            link: '/cdns',
            icon: <UnorderedListOutlined />,
          },
          {
            type: 'item',
            module: PERMISSIONS.addCDN,
            title: 'Add Note',
            key: 'Add Note',
            link: '/cdns/add',
            icon: <PlusCircleOutlined />,
          },
        ],
      },
      {
        type: 'list',
        title: 'Financial Reports',
        key: 'Financials.Module',
        icon: <AccountBookOutlined />,
        subModules: [
          {
            type: 'item',
            module: PERMISSIONS.financeReports,
            title: 'Accounts Report',
            key: 'Accounts Report',
            link: '/financials/accounts',
            icon: <BankOutlined />,
          },
          {
            type: 'item',
            module: PERMISSIONS.financeReports,
            title: 'Balance Sheet',
            key: 'Balance Sheet',
            link: '/financials/balance-sheet',
            icon: <AuditOutlined />,
          },
          {
            type: 'item',
            module: PERMISSIONS.financeReports,
            title: 'P/L Summary',
            key: 'Financial Summary',
            link: '/financials/financial-summary',
            icon: <BarChartOutlined />,
          },
        ],
      },
      {
        type: 'list',
        title: 'Old Accounts',
        key: 'Old.Accounts.Module',
        icon: <HistoryOutlined />,
        subModules: [
          {
            type: 'item',
            module: PERMISSIONS.getTransactions,
            title: 'Transactions',
            key: 'Transactions',
            link: '/old_accounts/oldtransactions',
            icon: <TransactionOutlined />,
          },
          {
            type: 'item',
            module: PERMISSIONS.getNarrations,
            title: 'Narrations',
            key: 'Narrations',
            link: '/accounts/narrations',
            icon: <UnorderedListOutlined />,
          },
          {
            type: 'item',
            module: PERMISSIONS.getBanks,
            title: 'Banks',
            key: 'Banks',
            link: '/old_accounts/oldbanks',
            icon: <BankOutlined />,
          },
          {
            type: 'item',
            module: PERMISSIONS.getContacts,
            title: 'Contacts',
            key: 'Contacts',
            link: '/accounts/contacts',
            icon: <ContactsOutlined />,
          },
          {
            type: 'item',
            module: PERMISSIONS.getAssets,
            title: 'Assets',
            key: 'Assets',
            link: '/accounts/assets',
            icon: <DatabaseOutlined />,
          },
          {
            type: 'item',
            module: PERMISSIONS.getAssets,
            title: 'Asset Adjust',
            key: 'Asset Adjust',
            link: '/accounts/assets/adjusts',
            icon: <SettingOutlined />,
          },
        ],
      },
    ],
  },

  // 7 Reports
  {
    type: 'list',
    title: 'Reports',
    key: 'Reports.Module',
    icon: <BarChartOutlined />,
    subModules: [
      // Sales Reports
      {
        type: 'item',
        module: PERMISSIONS.saleReport,
        title: 'Sale Report',
        key: 'Sale Report',
        link: '/reports/sale-report',
        icon: <UnorderedListOutlined />,
      },
      {
        type: 'item',
        module: PERMISSIONS.saleFigures,
        title: 'Sale Figures',
        key: 'Sale Figures',
        link: '/reports/sale-figures',
        icon: <UnorderedListOutlined />,
      },
      {
        type: 'item',
        module: PERMISSIONS.getProductSaleReport,
        title: 'Product Sale',
        key: 'Product Sale',
        link: '/reports/product-sale',
        icon: <UnorderedListOutlined />,
      },
      {
        type: 'item',
        module: PERMISSIONS.userWiseOrdersReport,
        title: 'User Wise Orders',
        key: 'User Wise Orders',
        link: '/reports/userwiseorders',
        icon: <UnorderedListOutlined />,
      },
      {
        type: 'item',
        module: PERMISSIONS.soInvoiceComparison,
        title: 'SO vs Invoice',
        key: 'SO vs Invoice Comparison',
        link: '/reports/so-invoice-comparison',
        icon: <UnorderedListOutlined />,
      },
      {
        type: 'item',
        module: PERMISSIONS.lastSellingProductGpValues,
        title: 'Product GP',
        key: 'Product GP Values',
        link: '/reports/lastsellinggp',
        icon: <UnorderedListOutlined />,
      },
      {
        type: 'item',
        module: PERMISSIONS.lastSellingProductGpValues,
        title: 'Composition GP',
        key: 'Composition GP Values',
        link: '/reports/composition-gp',
        icon: <UnorderedListOutlined />,
      },
      {
        type: 'item',
        module: PERMISSIONS.yearlyPIFigures,
        title: 'Yearly PI',
        key: 'Yearly PI Figures',
        link: '/reports/pi-figures/yearly',
        icon: <UnorderedListOutlined />,
      },
      {
        type: 'item',
        module: PERMISSIONS.saleFigures,
        title: 'Yearly Sales',
        key: 'Yearly Sale Figures',
        link: '/reports/sale-figures/yearly',
        icon: <UnorderedListOutlined />,
      },

      // Orders & Production Reports
      {
        type: 'item',
        module: PERMISSIONS.getCoaReport,
        title: 'COA Report',
        key: 'COA Report',
        link: '/reports/coa',
        icon: <SafetyCertificateOutlined />,
      },
      {
        type: 'item',
        module: PERMISSIONS.yearlyDispatchReport,
        title: 'Dispatch Report',
        key: 'Dispatch Report',
        link: '/reports/dispatch-report/yearly',
        icon: <UnorderedListOutlined />,
      },
      {
        type: 'item',
        module: PERMISSIONS.onTimeDeliveryReport,
        title: 'On Time Delivery',
        key: 'On Time Delivery',
        link: '/reports/on-time-delivery',
        icon: <UnorderedListOutlined />,
      },

      // Procurement Reports
      {
        type: 'item',
        module: PERMISSIONS.getMaterialSaleReport,
        title: 'Material Purchase',
        key: 'Material Purchase',
        link: '/reports/material-purchase',
        icon: <UnorderedListOutlined />,
      },
      {
        type: 'item',
        module: PERMISSIONS.onTimeReceivedReport,
        title: 'On Time Received',
        key: 'On Time Received',
        link: '/reports/on-time-received',
        icon: <UnorderedListOutlined />,
      },
      {
        type: 'item',
        module: PERMISSIONS.purchaseFigures,
        title: 'Yearly Purchase',
        key: 'Yearly Purchase Figures',
        link: '/reports/purchase-figures/yearly',
        icon: <UnorderedListOutlined />,
      },
    ],
  },

  // 6 Data Masters
  {
    type: 'list',
    title: 'Data Masters',
    key: 'DataCreation.Module',
    icon: <DatabaseOutlined />,
    subModules: [
      {
        type: 'list',
        title: 'Products',
        key: 'Products.Module',
        icon: <ExperimentOutlined />,
        subModules: [
          {
            type: 'item',
            module: PERMISSIONS.getProducts,
            title: 'Products',
            key: 'Products',
            link: '/products',
            icon: <UnorderedListOutlined />,
          },
          {
            type: 'item',
            module: PERMISSIONS.addProduct,
            title: 'Add Product',
            key: 'Add Product',
            link: '/products/add',
            icon: <PlusCircleOutlined />,
          },
          {
            type: 'item',
            module: PERMISSIONS.productCosting,
            title: 'Costing',
            key: 'Product Costing',
            link: '/products/costing',
            icon: <FileUnknownOutlined />,
          },
        ],
      },
      {
        type: 'list',
        title: 'Generics',
        key: 'Generics.Module',
        icon: <MedicineBoxOutlined />,
        subModules: [
          {
            type: 'item',
            module: PERMISSIONS.getGenerics,
            title: 'Generics',
            key: 'Generics',
            link: '/generics',
            icon: <UnorderedListOutlined />,
          },
          {
            type: 'item',
            module: PERMISSIONS.addGeneric,
            title: 'Add Generic',
            key: 'Add Generic',
            link: '/generics/add',
            icon: <PlusCircleOutlined />,
          },
        ],
      },
      {
        type: 'list',
        title: 'Materials',
        key: 'Materials.Module',
        icon: <DeploymentUnitOutlined />,
        subModules: [
          {
            type: 'item',
            module: PERMISSIONS.getMaterials,
            title: 'Materials',
            key: 'Materials',
            link: '/materials',
            icon: <UnorderedListOutlined />,
          },
          {
            type: 'item',
            module: PERMISSIONS.addMaterial,
            title: 'Add Material',
            key: 'Add Material',
            link: '/materials/add',
            icon: <PlusCircleOutlined />,
          },
        ],
      },
      {
        type: 'list',
        title: 'Parties',
        key: 'Parties.Module',
        icon: <ContactsOutlined />,
        subModules: [
          {
            type: 'item',
            module: PERMISSIONS.getParties,
            title: 'Parties',
            key: 'Parties',
            link: '/Parties',
            icon: <UnorderedListOutlined />,
          },
          {
            type: 'item',
            module: PERMISSIONS.addParty,
            title: 'Add Party',
            key: 'Add Party',
            link: '/parties/add',
            icon: <PlusCircleOutlined />,
          },
        ],
      },
      {
        type: 'list',
        title: 'Machines',
        key: 'Machines.Module',
        icon: <ControlOutlined />,
        subModules: [
          {
            type: 'item',
            module: PERMISSIONS.getMachines,
            title: 'Machines',
            key: 'Machines',
            link: '/machines',
            icon: <UnorderedListOutlined />,
          },
          {
            type: 'item',
            module: PERMISSIONS.addMachine,
            title: 'Add Machine',
            key: 'Add Machine',
            link: '/machines/add',
            icon: <PlusCircleOutlined />,
          },
        ],
      },
      {
        type: 'list',
        title: 'SOPs',
        key: 'Sops.Module',
        icon: <BookOutlined />,
        subModules: [
          {
            type: 'item',
            module: PERMISSIONS.getSops,
            title: 'SOPs',
            key: 'SOPs',
            link: '/sops',
            icon: <BookOutlined />,
          },
        ],
      },
      {
        type: 'list',
        title: 'Dropdowns',
        key: 'Dropdowns',
        icon: <AppstoreOutlined />,
        subModules: [
          {
            type: 'item',
            module: PERMISSIONS.getUnits,
            title: 'Units',
            key: 'Units',
            link: '/dropdowns/units',
            icon: <UnorderedListOutlined />,
          },
          {
            type: 'item',
            module: PERMISSIONS.getHsns,
            title: 'HSN',
            key: 'HSN',
            link: '/dropdowns/hsns',
            icon: <UnorderedListOutlined />,
          },
          {
            type: 'item',
            module: PERMISSIONS.getPackings,
            title: 'Packings',
            key: 'Packings',
            link: '/dropdowns/packings',
            icon: <UnorderedListOutlined />,
          },
          {
            type: 'item',
            module: PERMISSIONS.getCharges,
            title: 'Charges',
            key: 'Charges',
            link: '/dropdowns/charges',
            icon: <UnorderedListOutlined />,
          },
          {
            type: 'item',
            module: PERMISSIONS.getConsignors,
            title: 'Consignors',
            key: 'Consignors',
            link: '/dropdowns/consignors',
            icon: <UnorderedListOutlined />,
          },
          {
            type: 'item',
            module: PERMISSIONS.getMachines,
            title: 'Machine Sets',
            key: 'Machine Sets',
            link: '/dropdowns/machine-sets',
            icon: <UnorderedListOutlined />,
          },
        ],
      },
      {
        type: 'list',
        title: 'Chart of Accounts',
        key: 'DataCreation.Accounts.Module',
        icon: <ApartmentOutlined />,
        subModules: [
          {
            type: 'item',
            module: PERMISSIONS.getBanks,
            title: 'Banks',
            key: 'DataCreation Banks',
            link: '/accounts/banks',
            icon: <BankOutlined />,
          },
          {
            type: 'item',
            module: PERMISSIONS.getTransactions,
            title: 'Groups',
            key: 'DataCreation Groups',
            link: '/accounts/groups',
            icon: <SettingOutlined />,
          },
          {
            type: 'item',
            module: PERMISSIONS.getTransactions,
            title: 'Subgroups',
            key: 'DataCreation Subgroups',
            link: '/accounts/subgroups',
            icon: <SettingOutlined />,
          },
        ],
      },
      {
        type: 'list',
        title: 'Users & Roles',
        key: 'Users.Module',
        icon: <TeamOutlined />,
        subModules: [
          {
            type: 'item',
            module: PERMISSIONS.getUsers,
            title: 'Users',
            key: 'Users',
            link: '/users',
            icon: <UnorderedListOutlined />,
          },
          {
            type: 'item',
            module: PERMISSIONS.addUser,
            title: 'Add User',
            key: 'Add User',
            link: '/users/add',
            icon: <UserAddOutlined />,
          },
          {
            type: 'item',
            module: PERMISSIONS.getRoles,
            title: 'Roles',
            key: 'User Roles',
            link: '/users/roles',
            icon: <UnorderedListOutlined />,
          },
          {
            type: 'item',
            module: PERMISSIONS.addRole,
            title: 'Add Role',
            key: 'Add Role',
            link: '/users/roles/add',
            icon: <PlusCircleOutlined />,
          },
        ],
      },
    ],
  },
];

export const getSubModules = modules => {
  const list = [];

  modules.forEach(({ type, module, subModules }) => {
    if (type === 'item') {
      list.push(module);
    } else if (type === 'list' && subModules) {
      list.push(...getSubModules(subModules));
    }
  });

  return list;
};

const moduleLinkings = {};

const populateLinkings = items => {
  items.forEach(el => {
    if (el.type === 'item' && el.link && el.key) {
      moduleLinkings[el.link] = el.key;
    }
    if (el.subModules && el.subModules.length) {
      populateLinkings(el.subModules);
    }
  });
};

populateLinkings(Modules);

export const getDefaultSelectedKeys = (link = '') => moduleLinkings[link];
